import React, { useEffect } from 'react'
import { fetchAd } from 'careers/actions/job-ad'
import JobAdComponent from 'careers/containers/job-ad'
import FetchWithSpinner from 'components/fetch-with-spinner'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { I18nComponentType } from 'careers/i18n-types'
import { mapLanguageToComponentProps } from 'i18n'
import Error410 from 'components/errors/410'
import Error404 from 'components/errors/404'
import Unpublished from 'careers/components/unpublished'
import { PrimaryLink } from 'components/styled/typography'
import { setUnpublished } from 'careers/actions/job-ad'
import { httpError as httpErrorAction } from 'actions/http'


/**
 * Single Job Ad view on careers pages
 */

const mapStateToProps = (state: any) => ({
  httpError: state.global.httpError,
  unpublished: state.careers.unpublished,
})
function JobAd({ httpError, i18n, dispatch, unpublished }: { httpError?: number; i18n: I18nComponentType; dispatch: any; unpublished?: boolean }) {
  const params = useParams()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')

  useEffect(() => {
    dispatch(httpErrorAction(null))
    dispatch(setUnpublished(false))
  }, [])

   const renderErrorOrOutlet = () => {
    const link = `/careers/${params.language}/${params.companySlug}`

     if (httpError === 410) {
       return (
         <Error410>
           <PrimaryLink to={link}>{i18n.error410.link}</PrimaryLink>
         </Error410>
       )
     }
     if (httpError === 404) {
       return <Error404 />
     }
 
     if (unpublished) {
       return (
         <Unpublished>
           <PrimaryLink to={link}>{i18n.error404.link}</PrimaryLink>
         </Unpublished>
       )
     }
     return <Outlet />
   }

  return (
    <FetchWithSpinner action={() => fetchAd(params, token)}>
      <JobAdComponent />
      {renderErrorOrOutlet()}
    </FetchWithSpinner>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(JobAd)
